import { Typography, Grid, useMediaQuery, Skeleton, Container } from "@mui/material";
import { useTheme } from "@mui/system";

export function PropertyPageSkeleton() {
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down("sm"));
  const IMAGE_HEIGHT_MOBILE = 240;
  const IMAGE_HEIGHT_DEFAULT = 408;

  const imageHeight = isXS ? IMAGE_HEIGHT_MOBILE : IMAGE_HEIGHT_DEFAULT;

  return (
    <Container maxWidth={"lg"}>
      <Typography variant={"h1"} sx={{ marginBottom: 2 }}>
        <Skeleton sx={{ height: 40, width: "40%" }} />
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant={"rectangular"} sx={{ height: imageHeight, borderRadius: 1.5 }} />
        </Grid>
        {!isXS ? (
          <Grid item xs={12} sm={6}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }} sx={{ position: "relative" }}>
              <Grid item xs={6}>
                <Skeleton variant={"rectangular"} sx={{ height: 200, borderRadius: 1.5 }} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant={"rectangular"} sx={{ height: 200, borderRadius: 1.5 }} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant={"rectangular"} sx={{ height: 200, borderRadius: 1.5 }} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant={"rectangular"} sx={{ height: 200, borderRadius: 1.5 }} />
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <>
            <Skeleton sx={{ marginTop: 2, height: 40, width: "100%" }} />
            <Skeleton sx={{ marginTop: 0, height: 70, width: "100%" }} />
            <Skeleton sx={{ marginTop: 0, height: 90, width: "100%" }} />
            <Skeleton sx={{ marginTop: 0, height: 80, width: "100%" }} />
          </>
        )}
      </Grid>
      <Typography variant={"body2"} sx={{ marginTop: 2 }}>
        <Skeleton sx={{ height: 200, width: "60%" }} />
      </Typography>
    </Container>
  );
}
